// Tunable constants for the prototype. Anything that might change per-deployment lives here.

export const FADE_DURATION_MS = 400;

export const HOTSPOT_DEFAULT_DISTANCE = 12;
export const HOTSPOT_BILLBOARD_RADIUS = 0.45;

export const VR_GAZE_DWELL_MS = 1500;
export const VR_REFERENCE_SPACE: 'local-floor' | 'local' = 'local-floor';

export const PLACEHOLDER_PANORAMA_DIR = '/assets/panoramas';

// ── Time-of-day presets ─────────────────────────────────────────────────────
// Shared by the voice commands ("hora dourada", "à noite"), the sun panel and
// the in-VR menu. The hours used to exist only inside parseSunIntent(), so any
// second consumer had to re-guess them — and "golden hour" being 18:00 rather
// than 17:30 is exactly the kind of thing that drifts silently between surfaces.
// Labels are resolved per-locale at the call site, not stored here.
export type SunPresetId =
  | 'midnight' | 'dawn' | 'morning' | 'noon'
  | 'afternoon' | 'goldenHour' | 'dusk' | 'night';

export const SUN_PRESETS: ReadonlyArray<{ id: SunPresetId; hour: number }> = [
  { id: 'midnight', hour: 0 },
  { id: 'dawn', hour: 6 },
  { id: 'morning', hour: 9 },
  { id: 'noon', hour: 12 },
  { id: 'afternoon', hour: 15 },
  { id: 'goldenHour', hour: 18 },
  { id: 'dusk', hour: 19 },
  { id: 'night', hour: 21 },
];

export function sunPresetHour(id: SunPresetId): number {
  return SUN_PRESETS.find((p) => p.id === id)?.hour ?? 12;
}
